import { getTextToSpeechCode, LanguageInfo } from "./LanguageInfo";
import { post } from "./server";
import { SpeechToTextResponse } from "./SpeechToTextResponse";
import { store } from "./store";

export class AudioCreator {
  text!: string;
  language!: LanguageInfo;

  async create(): Promise<SpeechToTextResponse> {
    const code = getTextToSpeechCode(this.language);
    return await post("text-to-speech", {
      text: this.text,
      language: code,
      sessionId: store.state.sessionId,
    });
  }
}



